import React from 'react';
import { Box } from '@mui/material';
import { APEX_K9_BRAND } from '../../shared/apexK9Branding';

export type ApexK9TmScale = 'nav' | 'heading';

/** Superscript ™ — avoid lineHeight:0 and verticalAlign:super inside flex; use relative top. */
export function apexK9TmSuperscriptSx(scale: ApexK9TmScale = 'nav') {
  if (scale === 'heading') {
    return {
      fontSize: '0.5em',
      fontWeight: 700,
      lineHeight: 1,
      position: 'relative',
      top: '-0.55em',
      marginLeft: '0.08em',
      verticalAlign: 'baseline',
    } as const;
  }
  return {
    fontSize: '0.62em',
    fontWeight: 700,
    lineHeight: 1,
    position: 'relative',
    top: '-0.42em',
    marginLeft: '0.06em',
    verticalAlign: 'baseline',
  } as const;
}

export type ApexK9TitleWithTmProps = {
  /** `heading` for h4/h5 dashboard titles; `nav` for inline / menu labels. */
  scale?: ApexK9TmScale;
};

/** Inline wordmark: APEX K9 + superscript ™. Parent should set aria-label on the heading. */
export const ApexK9TitleWithTm: React.FC<ApexK9TitleWithTmProps> = ({ scale = 'nav' }) => (
  <Box component="span" sx={{ display: 'inline', whiteSpace: 'nowrap' }}>
    {APEX_K9_BRAND}
    <Box component="sup" aria-hidden="true" sx={apexK9TmSuperscriptSx(scale)}>
      ™
    </Box>
  </Box>
);
